import React, { memo } from 'react';

const HeroAnimation = memo(() => (
  <div className="hero-anim-wrap" aria-hidden="true">
    <svg viewBox="0 0 400 280" fill="none" xmlns="http://www.w3.org/2000/svg" className="hero-anim-svg">
      {/* Desk */}
      <rect x="120" y="220" width="160" height="8" rx="4" fill="#D4CFFF" className="ha-desk"/>
      <rect x="155" y="228" width="8" height="32" rx="2" fill="#B8B0E8"/>
      <rect x="237" y="228" width="8" height="32" rx="2" fill="#B8B0E8"/>

      {/* Chair */}
      <rect x="175" y="195" width="50" height="30" rx="8" fill="#7FB342" opacity="0.2"/>

      {/* Body */}
      <rect x="180" y="150" width="40" height="55" rx="12" fill="#7FB342" className="ha-body"/>
      {/* Arms */}
      <rect x="168" y="162" width="14" height="6" rx="3" fill="#D4A574"/>
      <rect x="218" y="162" width="14" height="6" rx="3" fill="#D4A574"/>

      {/* Head */}
      <circle cx="200" cy="128" r="22" fill="#D4A574" className="ha-head"/>
      {/* Hair */}
      <ellipse cx="200" cy="112" rx="20" ry="10" fill="#3A2E1A"/>
      <rect x="182" y="106" width="36" height="12" rx="6" fill="#3A2E1A"/>

      {/* Face - stress phase (default) */}
      <g className="ha-face-stress">
        <ellipse cx="192" cy="126" rx="2.5" ry="2.5" fill="#3A2E1A"/>
        <ellipse cx="208" cy="126" rx="2.5" ry="2.5" fill="#3A2E1A"/>
        {/* Frown eyebrows */}
        <line x1="187" y1="120" x2="195" y2="122" stroke="#3A2E1A" strokeWidth="2" strokeLinecap="round"/>
        <line x1="213" y1="120" x2="205" y2="122" stroke="#3A2E1A" strokeWidth="2" strokeLinecap="round"/>
        {/* Straight mouth */}
        <line x1="194" y1="135" x2="206" y2="135" stroke="#3A2E1A" strokeWidth="2" strokeLinecap="round"/>
      </g>

      {/* Face - neutral phase */}
      <g className="ha-face-neutral">
        <ellipse cx="192" cy="126" rx="2.5" ry="2.5" fill="#3A2E1A"/>
        <ellipse cx="208" cy="126" rx="2.5" ry="2.5" fill="#3A2E1A"/>
        <line x1="188" y1="121" x2="196" y2="121" stroke="#3A2E1A" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="212" y1="121" x2="204" y2="121" stroke="#3A2E1A" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="195" y1="135" x2="205" y2="135" stroke="#3A2E1A" strokeWidth="1.5" strokeLinecap="round"/>
      </g>

      {/* Face - smile phase */}
      <g className="ha-face-smile">
        <ellipse cx="192" cy="126" rx="2.5" ry="2.5" fill="#3A2E1A"/>
        <ellipse cx="208" cy="126" rx="2.5" ry="2.5" fill="#3A2E1A"/>
        <path d="M193 134 Q200 140 207 134" stroke="#3A2E1A" strokeWidth="2" strokeLinecap="round" fill="none"/>
      </g>

      {/* Floating papers */}
      <g className="ha-paper ha-paper-1">
        <rect x="125" y="100" width="36" height="26" rx="4" fill="#fff" stroke="#D4CFFF" strokeWidth="1.5"/>
        <text x="131" y="116" fontSize="7" fill="#7FB342" fontWeight="700" fontFamily="sans-serif">CAF</text>
      </g>
      <g className="ha-paper ha-paper-2">
        <rect x="240" y="90" width="48" height="26" rx="4" fill="#fff" stroke="#D4CFFF" strokeWidth="1.5"/>
        <text x="245" y="106" fontSize="7" fill="#7FB342" fontWeight="700" fontFamily="sans-serif">IMPÔTS</text>
      </g>
      <g className="ha-paper ha-paper-3">
        <rect x="140" y="60" width="60" height="26" rx="4" fill="#fff" stroke="#D4CFFF" strokeWidth="1.5"/>
        <text x="143" y="76" fontSize="6.5" fill="#059669" fontWeight="700" fontFamily="sans-serif">PRÉFECTURE</text>
      </g>

      {/* Phone in hand */}
      <g className="ha-phone">
        <rect x="218" y="155" width="16" height="26" rx="3" fill="#252538" stroke="#7FB342" strokeWidth="1"/>
        <rect x="220" y="158" width="12" height="18" rx="1.5" fill="#1A1A2E"/>
        {/* Phone glow */}
        <rect x="220" y="158" width="12" height="18" rx="1.5" fill="#7FB342" className="ha-phone-glow"/>
        {/* Checkmark on phone */}
        <path d="M223 166 L226 169.5 L231 163" stroke="#22C55E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ha-check" fill="none"/>
      </g>

      {/* Thought bubble - stress */}
      <g className="ha-bubble-stress">
        <circle cx="160" cy="95" r="11" fill="#fff" stroke="#E5E3F0" strokeWidth="1"/>
        <circle cx="168" cy="108" r="4" fill="#fff" stroke="#E5E3F0" strokeWidth="1"/>
        <circle cx="173" cy="115" r="2.5" fill="#fff" stroke="#E5E3F0" strokeWidth="1"/>
        <text x="155" y="99" fontSize="12" textAnchor="middle">😰</text>
      </g>

      {/* Thought bubble - smile */}
      <g className="ha-bubble-smile">
        <circle cx="160" cy="95" r="11" fill="#fff" stroke="#E5E3F0" strokeWidth="1"/>
        <circle cx="168" cy="108" r="4" fill="#fff" stroke="#E5E3F0" strokeWidth="1"/>
        <circle cx="173" cy="115" r="2.5" fill="#fff" stroke="#E5E3F0" strokeWidth="1"/>
        <text x="155" y="99" fontSize="12" textAnchor="middle">😊</text>
      </g>

      {/* Confetti */}
      <circle cx="150" cy="60" r="3" fill="#7FB342" className="ha-confetti ha-c1"/>
      <circle cx="250" cy="50" r="2.5" fill="#5B4FD9" className="ha-confetti ha-c2"/>
      <circle cx="180" cy="40" r="2" fill="#60A5FA" className="ha-confetti ha-c3"/>
      <circle cx="220" cy="55" r="3" fill="#7FB342" className="ha-confetti ha-c4"/>
      <circle cx="270" cy="70" r="2" fill="#C4B5FD" className="ha-confetti ha-c5"/>
    </svg>
    <style>{`
      .hero-anim-wrap{width:100%;max-width:320px;margin:0 auto;height:auto}
      .hero-anim-svg{width:100%;height:auto}

      /* Phase timing: 0-2.5s stress, 2.5-3s action, 3-6s relief */

      /* Papers float & tremble during stress, fly away during relief */
      .ha-paper{will-change:transform,opacity}
      .ha-paper-1{animation:paperFloat1 6s ease-in-out infinite}
      .ha-paper-2{animation:paperFloat2 6s ease-in-out infinite}
      .ha-paper-3{animation:paperFloat3 6s ease-in-out infinite}

      @keyframes paperFloat1{
        0%,10%{transform:translate(0,0) rotate(-2deg);opacity:1}
        20%{transform:translate(2px,-3px) rotate(2deg);opacity:1}
        35%{transform:translate(-2px,0) rotate(-2deg);opacity:1}
        42%{transform:translate(0,0) rotate(0);opacity:1}
        55%{transform:translate(-20px,-180px) rotate(-15deg);opacity:0}
        100%{transform:translate(-20px,-180px) rotate(-15deg);opacity:0}
      }
      @keyframes paperFloat2{
        0%,10%{transform:translate(0,0) rotate(2deg);opacity:1}
        20%{transform:translate(-3px,2px) rotate(-1deg);opacity:1}
        35%{transform:translate(2px,-2px) rotate(3deg);opacity:1}
        42%{transform:translate(0,0) rotate(0);opacity:1}
        58%{transform:translate(30px,-190px) rotate(20deg);opacity:0}
        100%{transform:translate(30px,-190px) rotate(20deg);opacity:0}
      }
      @keyframes paperFloat3{
        0%,10%{transform:translate(0,0) rotate(1deg);opacity:1}
        25%{transform:translate(3px,3px) rotate(-2deg);opacity:1}
        38%{transform:translate(-1px,-1px) rotate(1deg);opacity:1}
        42%{transform:translate(0,0) rotate(0);opacity:1}
        52%{transform:translate(5px,-200px) rotate(10deg);opacity:0}
        100%{transform:translate(5px,-200px) rotate(10deg);opacity:0}
      }

      /* Phone glow */
      .ha-phone-glow{opacity:0;animation:phoneGlow 6s ease-in-out infinite}
      @keyframes phoneGlow{
        0%,40%{opacity:0}
        42%,50%{opacity:0.7}
        55%{opacity:0.3}
        100%{opacity:0.3}
      }

      /* Checkmark */
      .ha-check{opacity:0;transform-origin:226px 166px;animation:checkPop 6s ease-in-out infinite}
      @keyframes checkPop{
        0%,48%{opacity:0;transform:scale(0)}
        52%{opacity:1;transform:scale(1.3)}
        55%,100%{opacity:1;transform:scale(1)}
      }

      /* Face phases */
      .ha-face-stress{animation:faceStress 6s step-end infinite}
      .ha-face-neutral{animation:faceNeutral 6s step-end infinite}
      .ha-face-smile{animation:faceSmile 6s step-end infinite}

      @keyframes faceStress{0%{opacity:1}42%{opacity:0}100%{opacity:0}}
      @keyframes faceNeutral{0%{opacity:0}42%{opacity:1}50%{opacity:0}100%{opacity:0}}
      @keyframes faceSmile{0%{opacity:0}50%{opacity:1}100%{opacity:1}}

      /* Thought bubbles */
      .ha-bubble-stress{animation:bubbleStress 6s step-end infinite}
      .ha-bubble-smile{animation:bubbleSmile 6s step-end infinite}
      @keyframes bubbleStress{0%{opacity:1}42%{opacity:0}100%{opacity:0}}
      @keyframes bubbleSmile{0%{opacity:0}50%{opacity:1}100%{opacity:1}}

      /* Confetti */
      .ha-confetti{opacity:0;will-change:transform,opacity;animation:confettiFall 6s ease-in-out infinite}
      .ha-c1{animation-delay:0s}
      .ha-c2{animation-delay:0.15s}
      .ha-c3{animation-delay:0.3s}
      .ha-c4{animation-delay:0.1s}
      .ha-c5{animation-delay:0.25s}
      @keyframes confettiFall{
        0%,50%{opacity:0;transform:translateY(0)}
        55%{opacity:1;transform:translateY(0)}
        85%{opacity:0.5;transform:translateY(60px)}
        100%{opacity:0;transform:translateY(80px)}
      }

      /* Head subtle shake during stress */
      .ha-head{animation:headShake 6s ease-in-out infinite}
      @keyframes headShake{
        0%{transform:translate(0,0)}
        5%{transform:translate(-1px,0)}
        10%{transform:translate(1px,0)}
        15%{transform:translate(-1px,0)}
        20%{transform:translate(0,0)}
        100%{transform:translate(0,0)}
      }

      /* Accessibility */
      @media(prefers-reduced-motion:reduce){
        .ha-paper,.ha-phone-glow,.ha-check,.ha-face-stress,.ha-face-neutral,.ha-face-smile,
        .ha-bubble-stress,.ha-bubble-smile,.ha-confetti,.ha-head{animation:none!important}
        .ha-face-smile,.ha-bubble-smile,.ha-check{opacity:1}
        .ha-face-stress,.ha-face-neutral,.ha-bubble-stress,.ha-confetti,.ha-phone-glow{opacity:0}
        .ha-paper{opacity:0}
      }
    `}</style>
  </div>
));

HeroAnimation.displayName = 'HeroAnimation';
export default HeroAnimation;
